import { Flex, VStack } from "@chakra-ui/react";
import { NoPathsFoundState } from "components/EmptyComponents/RandomEmptyState";
import CreatePathButtonWithModal from "features/Path/Components/Button/CreatePathButtonWithModal";

export default function PathListEmptyState() {
  return (
    <Flex w="100%" justify="center" py="10">
      <VStack spacing="4">
        <NoPathsFoundState />
        <CreatePathButtonWithModal variant="primary" />
      </VStack>
    </Flex>
  );
}
